import {useTranslation} from '@/translations/i18n.tsx'
import {FC, RefObject, useState} from 'react'
import {InputAddressAutocomplete} from '@components/commons/input-address-autocomplete'
import {Coordinates} from '@features/settings/types'
import {Button} from '@components/ui/button'
import {ModalHeaderTitle} from '@components/ui/modal-atoms'
import {Sheet, SheetContent, SheetTrigger} from '@components/ui/sheet'
import {useMediaQuery} from '@hooks/use-media-query'

interface AddAddressSectionProps {
    buttonText: string
    onSelectAddress: (fullAddressValue: google.maps.GeocoderResult, latLng: Coordinates) => void
    disabled?: boolean
    anchor?: RefObject<HTMLElement | null>
}
export const AddAddressSection: FC<AddAddressSectionProps> = ({onSelectAddress, buttonText, disabled, anchor}) => {
    const {t} = useTranslation()
    const isLarge = useMediaQuery({breakpoint: 'md'})
    const [open, setOpen] = useState(false)

    const onSelectAddressAutocomplete = (fullAddressValue: google.maps.GeocoderResult, latLng: Coordinates) => {
        !isLarge && setOpen(false)
        onSelectAddress(fullAddressValue, latLng)
    }

    if (isLarge) {
        return (
            <InputAddressAutocomplete
                trigger={
                    <Button shape="text" variant="tertiary">
                        {buttonText}
                    </Button>
                }
                anchor={anchor}
                onChange={onSelectAddressAutocomplete}
                predictionTypes={['address']}
                disabled={disabled}
                placeholder={t('settings:personal_information:enter_address_placeholder')}
            />
        )
    }

    return (
        <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger
                render={
                    <Button shape="text" variant="tertiary" disabled={disabled}>
                        {buttonText}
                    </Button>
                }
            />
            <SheetContent className="h-[calc(100%-(--spacing(5)))]">
                <ModalHeaderTitle>{t('settings:personal_information:change_address_action')}</ModalHeaderTitle>

                <InputAddressAutocomplete
                    staticView
                    onChange={onSelectAddressAutocomplete}
                    predictionTypes={['address']}
                    disabled={disabled}
                    placeholder={t('settings:personal_information:enter_address_placeholder')}
                />
            </SheetContent>
        </Sheet>
    )
}
